export default {
  // check auth
  get: function get() {
    return localStorage.getItem('meldapi') ? localStorage.getItem('meldapi') : false;
  },
  login: function login(data) {
    if (process.env.NODE_ENV === 'development') {
      localStorage.setItem('meldapi', true);
    } else {
      localStorage.setItem('meldapi', true);
    }
  },
  logout: function logout() {
    localStorage.removeItem('meldapi');
  }
};